import { Box, Stack, Typography } from "@mui/material";
import loader from "../../_assets/images/loading.gif";

interface IProps {
    showTitle: boolean,
    customTitle?: string,
    hideImg?: boolean
  }

const loaderBox = (props: IProps) => {

    const {showTitle, customTitle, hideImg} = props;

    return (

    <Box className="progress-bar loading-card">
        <Box sx={{ textAlign: "center" }}>

            {hideImg !== true && (
                <>
                    <img src={loader} />
                    
                </>
                
            )}
            
            {showTitle  &&  (
                <Typography variant="body2" sx={{ marginTop: 1, position: "absolute", left:"0", width: "100%" }}>
                    {customTitle !== undefined ? customTitle : "Processing..."}
                </Typography>
            )}

        </Box>
    </Box>

    )
}

export default loaderBox;